import { Contenedor, Cupo } from 'app/view/impo/impo';
import { Component, OnInit, Input } from '@angular/core';

@Component({
	moduleId: module.id,
	selector: 'app-generic-box-box',
	template: `
		{{contenedor.nroDetalleDo}}
  	`
})


export class GenericBoxComponentBox implements OnInit {
	@Input()
	contenedor: Contenedor;

	@Input()
	cupo: Cupo;
	constructor() { }

	ngOnInit() {
		if (!this.contenedor) {
			this.contenedor = new Contenedor();
		}

		if (!this.cupo) {
			this.cupo = new Cupo();
		}
	}
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/drag_expo/generic-box/generic-box.component.ts